import { CollectionTemplate } from './collection';

export default CollectionTemplate;
